import { Component, OnInit } from "@angular/core";
import { JobStatusService } from "../../jobStatus/jobStatus.service";
import { CustomerConfig } from "../../shared/interfaces";

@Component({
  selector: "official-enrollment-rules",
  templateUrl: "./official-enrollment-rules.component.html",
  styleUrls: ["./official-enrollment-rules.component.scss"],
})
export class OfficialEnrollmentRulesComponent implements OnInit {
  constructor(public jobStatusService: JobStatusService) {}
  customerConfig: CustomerConfig;
  titlesAndDescriptions = {
    minDaysEnrolled: {
      title: "Minimum Days Enrolled",
      description: `Enter the minimum number of days students must be enrolled to count in metrics that are based off of a starting cohort.
      This value is used to calculate metrics that are based off of a starting cohort within a time period, such as YOY Retention.
      This value is not used in the Enrollment metric. If no minimum number of days is needed, enter 0.`,
    },
    enrollmentWindows: {
      title: "Enrollment Windows",
      description: ` Enter the start and end dates for the official enrollment window. 
      If your official enrollment window is only one date, please enter the same date in both fields. 
      This window is used to calculate metrics that are based off of a starting cohort within a time period, such as YOY Retention. 
      This data is not used for the Enrollment metric.`,
    },
    noShows: {
      title: "No Shows",
      description: `Indicate if students who are marked as “No Show” should be included in metric calculations. 
      If “No Shows” are not included, these students may still be included in deep dive reports around enrollment and attrition.`,
    },
  };

  ngOnInit() {
    this.jobStatusService.getConfigForCustomer().subscribe(
      (data: CustomerConfig) => {
        this.customerConfig = data;
        this.jobStatusService.customerConfig = this.customerConfig;
        this.jobStatusService.updateCustomerConfig(this.customerConfig);
      },
      (error) => {
        console.log(error);
      }
    );
  }

  showSaveChangesBtn() {
    return (
      this.jobStatusService.customerConfig &&
      this.jobStatusService.updatedCustomerConfig &&
      this.jobStatusService.hasUpdates()
    );
  }

  saveChanges(element, text) {
    element.textContent = text;
    element.disabled = true;
    this.jobStatusService.saveChanges().subscribe(
      () => {
        this.customerConfig = {
          ...this.jobStatusService.updatedCustomerConfig,
        };
        this.jobStatusService.customerConfig = this.customerConfig;
        element.textContent = "SAVE";
        element.disabled = false;
      },
      (error) => {
        console.log(error);
        element.textContent = "SAVE";
        element.disabled = false;
      }
    );
  }
}
